import React from "react";
import { CellContext } from "@tanstack/react-table";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "../../ui/dropdown-menu";
import { AppContext } from "@/App";
import { PageLockContext } from "@/Components/PageLockProvider";

export const RaisedByCell = ({ getValue, row: { index }, column: { id }, table }: CellContext<any, unknown>) => {
    const app = React.useContext(AppContext);
    const users = app.teamMembers.concat(app.projectManagers).concat(app.sponsors);
    const lock = React.useContext(PageLockContext);
    const editingEnabled = app.applicationUser?.userSettings?.inlineTableEditing ?? false;

    const initialValue = getValue()
    // We need to keep and update the state of the cell normally
    const [owner, setOwner] = React.useState(initialValue)

    // When the input is blurred, we'll call our table meta's updateData function
    const onBlur = (userName: string) => {
        setOwner(userName);
        table.options.meta?.updateData(index, id, userName);
    }

    // If the initialValue is changed external, sync it up with our state
    React.useEffect(() => {
        setOwner(initialValue)
    }, [initialValue])

    if (app.authLevel !== 3 && !lock.viewOnly && editingEnabled) { // only allow editing for non-viewers
        return (
            <DropdownMenu
                key={id + "_owner_dropdown_"+index}
            >
                <DropdownMenuTrigger asChild>
                    <button className="ml-4 w-[100px] bg-transparent outline-none text-center focus:outline-none"
                            id={id + "_owner_button_" + index}
                    >
                        {owner ? owner as string : "Unassigned"}
                    </button>
                </DropdownMenuTrigger>
                <DropdownMenuContent align="center">
                    {users.map((user) => (
                        <DropdownMenuItem key={user.id}
                            onClick={() => {
                                onBlur(user.displayName);
                            }}
                            className="flex flex-row justify-between">
                            <div className="flex flex-row text-center max-w-[200px]">{user.displayName}</div>
                        </DropdownMenuItem>
                    ))}
                    <DropdownMenuItem key={"unassigned"}
                        onClick={(e) => {
                            e.stopPropagation();

                        }}
                        className="flex flex-row justify-between">
                        <div className="flex flex-row text-center max-w-[100px]">Unassigned</div>
                    </DropdownMenuItem>
                </DropdownMenuContent>
            </DropdownMenu>
        );
    }
    return <div className="text-center">{owner as string}</div>
};